export var detachArrayBuffer = function detachArrayBuffer(arrayBuffer) {
  var _MessageChannel = new MessageChannel(),
    port1 = _MessageChannel.port1;
  port1.postMessage(arrayBuffer, [arrayBuffer]);
};